export const idiomas = {
  ESPANOL: 1,
  PORTUGUES: 2,
  INGLES: 3,
  FRANCES: 4,
  ALEMAN: 5,
  ITALIANO: 6,
  POLACO: 7,
  HOLANDES: 8,
  GRIEGO: 9,
}

export const getIdioma = idiomaId => {
  switch (idiomaId) {
    case idiomas.ESPANOL:
      return {
        nombre: 'Español',
        abreviatura: 'ES',
        value: idiomas.ESPANOL,
        idiomaColumnField: 'es',
      }
    case idiomas.PORTUGUES:
      return {
        nombre: 'Portugués',
        abreviatura: 'PT',
        value: idiomas.PORTUGUES,
        idiomaColumnField: 'pt',
      }
    case idiomas.INGLES:
      return { nombre: 'Inglés', abreviatura: 'EN', value: idiomas.INGLES, idiomaColumnField: 'en' }
    case idiomas.FRANCES:
      return {
        nombre: 'Francés',
        abreviatura: 'FR',
        value: idiomas.FRANCES,
        idiomaColumnField: 'fr',
      }
    case idiomas.ALEMAN:
      return { nombre: 'Aleman', abreviatura: 'DE', value: idiomas.ALEMAN, idiomaColumnField: 'de' }
    case idiomas.ITALIANO:
      return {
        nombre: 'Italiano',
        abreviatura: 'IT',
        value: idiomas.ITALIANO,
        idiomaColumnField: 'it',
      }
    case idiomas.POLACO:
      return {
        nombre: 'Polaco',
        abreviatura: 'PL',
        value: idiomas.POLACO,
        idiomaColumnField: 'pl',
      }
    case idiomas.HOLANDES:
      return {
        nombre: 'Holandes',
        abreviatura: 'NL',
        value: idiomas.HOLANDES,
        idiomaColumnField: 'nl',
      }
    case idiomas.GRIEGO:
      return {
        nombre: 'Griego',
        abreviatura: 'GR',
        value: idiomas.GRIEGO,
        idiomaColumnField: 'el',
      }
    default:
      return { nombre: '', abreviatura: '', idiomaColumnField: '' }
  }
}

export const getIdiomas = () => {
  const idiomasArray = []
  idiomasArray.push(getIdioma(idiomas.ESPANOL))
  idiomasArray.push(getIdioma(idiomas.INGLES))
  idiomasArray.push(getIdioma(idiomas.FRANCES))
  idiomasArray.push(getIdioma(idiomas.ALEMAN))
  idiomasArray.push(getIdioma(idiomas.ITALIANO))
  idiomasArray.push(getIdioma(idiomas.POLACO))
  idiomasArray.push(getIdioma(idiomas.PORTUGUES))
  idiomasArray.push(getIdioma(idiomas.HOLANDES))
  idiomasArray.push(getIdioma(idiomas.GRIEGO))

  return idiomasArray
}
